import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

/**
 * Validador personalizado para comprobar la validez de la fecha de expiración.
 *
 * Esta función devuelve una función de validación (`ValidatorFn`) que puede ser utilizada
 * en formularios para verificar si la fecha de expiración cumple con los criterios definidos.
 *
 * @returns Función de validación que evalúa la validez de la fecha de expiración.
 */
export function expirationDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control.value ? moment(control.value) : null;
    return date && date.isBefore(moment(), 'day')
      ? { expirationDate: true }
      : null;
  };
}
